import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from 'app/components/common/icon';
import utils from 'app/helpers/utils';

// To test users who start their week with Monday
// if (__IS_CLIENT__) {
//   moment.updateLocale('en', {week: {dow: 1}});
// }

const frmt = 'YYYY-MM-DD';
const weekDayLabels = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

class Calendar extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onClickPrevYear  = this.onClickPrevYear.bind(this);
    this.onClickPrevMonth = this.onClickPrevMonth.bind(this);
    this.onClickNextMonth = this.onClickNextMonth.bind(this);
    this.onClickNextYear  = this.onClickNextYear.bind(this);
  }

  get monthMoment() {
    return moment(this.props.monthDateStr, frmt);
  }

  get nextMonthDisabled() {
    if (!this.props.noFuture) return false;
    return this.monthMoment.format('YYYY-MM') >= moment.utc().format('YYYY-MM');
  }

  get nextYearDisabled() {
    if (!this.props.noFuture) return false;
    return this.monthMoment.clone().add(1, 'year').startOf('month').isAfter();
  }

  onClickDate(date) {
    this.props.onSelectDate(date.format(frmt));
  }

  onClickPrevYear() {
    const newMonthDateStr = this.monthMoment.clone().subtract(1, 'year').format(frmt);
    this.props.onChangeMonthDate(newMonthDateStr);
  }

  onClickPrevMonth() {
    const newMonthDateStr = this.monthMoment.clone().subtract(1, 'month').format(frmt);
    this.props.onChangeMonthDate(newMonthDateStr);
  }

  onClickNextMonth() {
    const newMonthDateStr = this.monthMoment.clone().add(1, 'month').format(frmt);
    this.props.onChangeMonthDate(newMonthDateStr);
  }

  onClickNextYear() {
    const newMonthDateStr = this.monthMoment.clone().add(1, 'year').format(frmt);
    this.props.onChangeMonthDate(newMonthDateStr);
  }

  render() {
    const { className, startDateStr, endDateStr, noFuture } = this.props;
    const startMoment = moment(startDateStr, frmt);
    const endMoment = moment(endDateStr, frmt);
    const hasRange = startMoment.isBefore(endMoment, 'day');
    const firstDay = this.monthMoment.clone().startOf('month').startOf('week');
    const lastDay = this.monthMoment.clone().endOf('month').endOf('week');
    const dates = [];
    for (let i = firstDay.clone(); i.isSameOrBefore(lastDay, 'day'); i.add(1, 'day')) {
      dates.push(i.clone());
    }

    return (
      <div className={`calendar ${className}`}>
        <div className="calendar-month">
          <button title="Previous Year" onClick={this.onClickPrevYear}><Icon.CaretDouble direction="left" /></button>
          <button title="Previous Month" onClick={this.onClickPrevMonth}><Icon.Caret direction="left" /></button>
          <div className="calendar-month-label">{this.monthMoment.format('MMM YYYY')}</div>
          <button title="Next Month" disabled={this.nextMonthDisabled} onClick={this.onClickNextMonth}><Icon.Caret direction="right" /></button>
          <button title="Next Year" disabled={this.nextYearDisabled} onClick={this.onClickNextYear}><Icon.CaretDouble direction="right" /></button>
        </div>
        {dates.slice(0,7).map((date) => {
          const key = `header-${date.format(frmt)}`;
          return <div className="calendar-day header" key={key}>{weekDayLabels[date.day()]}</div>;
        })}
        {dates.map((date, i) => {
          const dateStr = date.format(frmt);
          const isFuture = date.isAfter();
          const isTrailing = !date.isSame(this.monthMoment, 'month');
          const disabled = !!((isFuture && noFuture) || isTrailing);
          const className = utils.classNames({
            'calendar-day': true,
            trailing: isTrailing,
            start: date.isSame(startMoment, 'day'),
            end: date.isSame(endMoment, 'day'),
            range: hasRange && date.isSameOrAfter(startMoment, 'day') && date.isSameOrBefore(endMoment, 'day'),
            today: date.isSame(moment(), 'day'),
            disabled,
          });
          return (
            <div className={className} key={dateStr} onClick={disabled ? undefined : this.onClickDate.bind(this, date)}>
              {date.date()}
            </div>
          );
        })}
      </div>
    );
  }

}

Calendar.propTypes = {
  className: PropTypes.string.isRequired,
  monthDateStr: PropTypes.string,
  startDateStr: PropTypes.string,
  endDateStr: PropTypes.string,
  onSelectDate: PropTypes.func,
  onChangeMonthDate: PropTypes.func,
  noFuture: PropTypes.bool,
};

Calendar.defaultProps = {
  className: '',
  monthDateStr: moment().format(frmt),
  onSelectDate: (selectedDateStr) => {},
  onChangeMonthDate: (monthDateStr) => {},
  noFuture: false,
};

export default Calendar;
